<ion-input [formControl]="formControl" [maxlength]="20" type="tel"></ion-input>
